import { SILENT, createAction } from 'uix/actions';
import { mergePersisted } from 'uix/persist/actions';
export const loadCfgOcr = createAction('LOAD_CFG_OCR', ()=>({}), SILENT) // spam if multiple table cells trigger load
;
export const setCfgOcr = createAction('SET_CFG_OCR', (cfg)=>({
        cfg
    }));
// VLM access
export const setFulltextAdminShowViewer = (showViewer)=>mergePersisted('Part/FulltextEditor/FulltextAdminOptions', {
        showViewer
    });
